'use client';

import { FullStory } from './FullStory';
import { FullStoryCrossDomainSync } from './FullStoryCrossDomainSync';
import { installFullStoryLoggingStub } from './fullstory-logging-stub';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';

import React, { useEffect } from 'react';

if (isFullStoryLoggingEnabled() && !isFullStoryEnabled()) {
  // If FullStory is not enabled but logging is, we want to initialize the logger early enough
  // that it captures events that would normally be captured by real FullStory
  installFullStoryLoggingStub();
}

export const FullStoryLoader: React.FC = () => {
  const { cloudPortalClientTelemetryCollection } = useFlagsProxy();
  const shouldRecord = isFullStoryEnabled() && cloudPortalClientTelemetryCollection;

  useEffect(() => {
    const applyRecordingState = () => {
      if (shouldRecord) {
        window.FS?.restart?.();
      } else {
        window.FS?.shutdown?.();
      }
    };

    if (window.FS) {
      applyRecordingState();

      return;
    }

    const poll = setInterval(() => {
      if (window.FS) {
        installFullStoryLoggingStub();
        applyRecordingState();
        clearInterval(poll);
      }
    }, 100);

    return () => clearInterval(poll);
  }, [shouldRecord]);

  if (!shouldRecord) {
    return null;
  }

  return (
    <>
      <FullStory />
      <FullStoryCrossDomainSync />
    </>
  );
};

function isFullStoryEnabled() {
  return process.env.FULLSTORY_ENABLED === 'true';
}

function isFullStoryLoggingEnabled() {
  return process.env.FULLSTORY_LOGGING === 'true';
}
